import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import moment from "moment-timezone";

const noonReportApi = AiseaApiFactory.get("noonReport");

export default {
  // 動静連絡バージョン定義のIDとアイテムを紐づける
  async getReportItems({ state, commit }) {
    const res = await noonReportApi.getVersions();
    if (!res || !res.data) throw res;

    const versions = res.data;
    const reportItems = versions.find(item => {
      return state.versionId === item.id;
    });

    if (!reportItems) return;
    commit("SET_REPORT_ITEMS", reportItems);
  },

  // 動静連絡詳細取得
  async getReportDetail({ commit }, payload) {
    const res = await noonReportApi.getReportDetail(
      payload.vesselId,
      payload.reportId
    );
    if (!res || !res.data) throw res;

    const reports = res.data;
    const contents = reports.contents
      ? JSON.parse(reports.contents.replaceAll("&#34;", '"'))
      : [];

    commit("SET_REPORT_ID", reports.id);
    commit("SET_VERSION", reports.version);
    commit("SET_VERSION_ID", reports.version_id);
    commit("SET_VESSEL_DETAIL", reports.enterprise_vessel);
    commit("SET_CREATED", reports.created_at);
    commit("SET_UPDATED", reports.updated_at);
    commit("SET_DETAIL", contents);
    commit("SET_WORK_FLOW_STATUS", reports.workflow_status);
    commit("SET_HISTORIES", reports.histories);
    commit("SET_SENDER", reports.changerProfile);

    let today = [];
    let yesterday = [];
    let more = [];
    reports.histories.forEach(el => {
      let msg = `${el.changerProfile.name}さんが${el.change}しました。`;
      let cmt = el.comment;
      let isoDateTime = new Date(el.created_at).toISOString();
      let createdAtJST = moment(isoDateTime)
        .tz("Asia/Tokyo")
        .format("YYYY/MM/DD HH:mm");
      let dateTo = moment();
      let dateFrom = moment(createdAtJST);
      let diff = dateTo.diff(dateFrom, "days");
      if (dateTo.isSame(dateFrom, "day")) {
        today.push({
          id: `to-${today.length + 1}`,
          msg,
          cmt,
          time: createdAtJST,
        });
      } else if (diff <= 1) {
        yesterday.push({
          id: `ye-${yesterday.length + 1}`,
          msg,
          cmt,
          time: createdAtJST,
        });
      } else {
        more.push({
          id: `mo-${more.length + 1}`,
          msg,
          cmt,
          time: createdAtJST,
        });
      }
    });

    commit("SET_GROUPED_HISTORIES", {
      today,
      yesterday,
      more,
    });
  },

  // 動静連絡入力内容更新
  async setReportDetail(_, payload) {
    const res = await noonReportApi.updateReport(
      payload.vesselId,
      payload.reportId,
      payload.requestBody
    );

    if (!res) {
      throw { msg: `エラーが発生しました。` };
    }

    if (res.status) return;

    if (!res.data.error_code) {
      throw { msg: `エラーが発生しました。` };
    }

    switch (res.data.error_code) {
      case 103:
        throw { msg: `編集権限がありません。` };
      case 104:
        throw { msg: `すでに編集済みのため編集できません。` };
      default:
        throw { msg: `エラーが発生しました。` };
    }
  },

  // 動静連絡トランザクション実行
  async setReportTransaction(_, payload) {
    const res = await noonReportApi.updateTransaction(
      payload.vesselId,
      payload.reportId,
      payload.transactionId,
      payload.requestBody
    );

    if (!res) {
      throw { msg: `エラーが発生しました。` };
    }

    if (res.status) return;

    if (!res.data.error_code) {
      throw { msg: `エラーが発生しました。` };
    }

    switch (res.data.error_code) {
      case 102:
      case 103:
        throw { msg: `${payload.actionName}権限がありません。` };
      case 104:
        throw {
          msg: `すでにステータス変更済みのため${payload.actionName}できません。`,
        };
      default:
        throw { msg: `エラーが発生しました。` };
    }
  },

  async resetState({ commit }) {
    const defaultState = {
      reportId: null,
      versionId: null,
      created: null,
      updated: null,
      version: null,
      sender: {},
      vesselDetail: {},
      reportItems: [],
      reportDetail: {},
      workflowStatus: {},
      histories: [],
      groupedHistories: {
        today: [],
        yesterday: [],
        more: [],
      },
    };

    commit("RESET_STATE", defaultState);
  },
};
